import { TechnologyContext } from 'context/TechnologyContext';
import { File, FileEdit, FileStack, X } from 'lucide-react';
import React, { useContext } from 'react';

const GanttContextMenu = ({ setModalGrupyOpen,contextMenu, onClose, onShowDetails, onSelectOrder }) => {
  const {fechparametryTechnologii} = useContext(TechnologyContext);
  if (!contextMenu) return null;


  return (
    <>
      {/* Przezroczysta warstwa na cały ekran blokująca interakcję i zamykająca menu po kliknięciu gdziekolwiek */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 999,
          background: 'transparent'
        }}
        onClick={onClose}
        onContextMenu={(e) => {
          e.preventDefault();
          onClose();
        }}
      />

      {/* Właściwe menu kontekstowe */}
      <div
        style={{
          position: 'fixed',
          top: contextMenu.y,
          left: contextMenu.x,
          background: '#2b2b2b',
          color: '#ffffff',
          border: '1px solid #444',
          borderRadius: '6px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
          zIndex: 1000,
          padding: '6px 0',
          minWidth: '160px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '6px 12px', fontSize: '12px', borderBottom: '1px solid #444', color: '#aaa' }}>
           {contextMenu.stage.nr} {contextMenu.stage.rok}  {contextMenu.stage.firma_nazwa} {contextMenu.stage.tytul} 
        
        </div>
        {/* <button
          style={{ width: '100%', textAlign: 'left', background: 'transparent', border: 'none', color: '#fff', padding: '8px 12px', cursor: 'pointer' }}
          onMouseEnter={(e) => e.target.style.background = '#3a3a3a'}
          onMouseLeave={(e) => e.target.style.background = 'transparent'}
          onClick={() => {
            onShowDetails(contextMenu.stage);
            onClose();
          }}
        >
          Szczegóły / Edytuj
        </button> */}
        {/* <button
          style={{ width: '100%', textAlign: 'left', background: 'transparent', border: 'none', color: '#ff4d4f', padding: '8px 12px', cursor: 'pointer' }}
          onMouseEnter={(e) => e.target.style.background = '#3a3a3a'}
          onMouseLeave={(e) => e.target.style.background = 'transparent'}
          onClick={() => {
            onSelectOrder(contextMenu.stage);
            onClose();
          }}
        >
          Zaznacz zlecenie
        </button> */}
                <button
          style={{ width: '100%', textAlign: 'left', background: 'transparent', border: 'none', color: '#aaaaaa', padding: '8px 12px', cursor: 'pointer' }}
          onMouseEnter={(e) => e.target.style.background = '#3a3a3a'}
          onMouseLeave={(e) => e.target.style.background = 'transparent'}
          onClick={() => {
            // onSelectOrder(contextMenu.stage);
            setModalGrupyOpen(true)
            fechparametryTechnologii(contextMenu.stage.zamowienie_id,contextMenu.stage.technologia_id)
            onClose();
          }}
        >
       <FileStack size={20} style={{marginRight:"15px"}}/>   Arkusze
        </button>
      </div>
    </>
  );
};

export default GanttContextMenu;